/**
 * Builds query string from filter object, excluding empty/null/undefined values
 * @param {Object} filters - Filter parameters to apply to the query
 * @returns {string} Query string starting with '&' if filters exist, empty string otherwise
 */
export const buildFilterQueryString = (filters = {}) => {
  if (Object.keys(filters).length === 0) return '';

  const queryParams = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== null && value !== '') {
      queryParams.append(key, value);
    }
  }
  const queryString = queryParams.toString();
  return queryString ? `&${queryString}` : '';
};
